import React, { useState, useEffect } from 'react';
import ReportingPageLayout from './ReportingPageLayout';
import ComparisonEventSelector from './ComparisonEventSelector';
import CompareEventsChart from './CompareEventsChart';
import useReportingPage from '../hooks/useReportingPage';

const axios = require('axios').default;

function getInitialEventA(eventOptions) {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get('eventA');
  if (!raw) return null;
  const id = parseInt(raw, 10);
  if (!id || !eventOptions?.some((e) => e.id === id)) return null;
  return id;
}

function ReportingCompareEventsPage({ team, eventOptions }) {
  const {
    isMobile, sidebarOpen, setSidebarOpen,
  } = useReportingPage('this_month');

  const [eventA, setEventA] = useState(() => getInitialEventA(eventOptions));
  const [eventB, setEventB] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!team?.id || !eventA) {
      setData(null);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const fetchParams = { event_a_id: eventA };
        if (eventB) fetchParams.event_b_id = eventB;
        const res = await axios.get(
          `/teams/${team.id}/reporting/dashboard/sales/compare-events/data.json`,
          { params: fetchParams }
        );
        setData(res.data);
      } catch (e) {
        setError('Failed to load comparison data. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [team?.id, eventA, eventB]);

  const eventSelector = (
    <ComparisonEventSelector
      eventOptions={eventOptions || []}
      eventA={eventA}
      eventB={eventB}
      onSelectA={setEventA}
      onSelectB={setEventB}
    />
  );

  return (
    <ReportingPageLayout
      team={team}
      activeKey="sales_compare"
      title="Compare Events"
      subtitle="Compare sales performance between two events side by side."
      dateRange={{}}
      setDateRange={() => {}}
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setSidebarOpen={setSidebarOpen}
      filterSidebarOpen={false}
      setFilterSidebarOpen={() => {}}
      activeFilters={{}}
      filterGroups={[]}
      handleFilterChange={() => {}}
      handleRemoveFilter={() => {}}
      handleClearAllFilters={() => {}}
      filterTitle=""
      filterSubtitle=""
      showDatePicker={false}
      showFilters={false}
      toolbarExtras={eventSelector}
    >
      {error && <div className="alert alert-danger">{error}</div>}

      {!eventA ? (
        <div
          className="text-center py-5"
          style={{
            background: 'var(--sl-bg-primary, #fff)',
            border: '1px solid var(--sl-border-secondary, #e4e7ec)',
            borderRadius: 8,
            color: 'var(--sl-text-tertiary, #667085)',
          }}
        >
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={{ marginBottom: 12 }}>
            <path d="M16 24H32M24 16V32M24 44C35 44 44 35 44 24C44 13 35 4 24 4C13 4 4 13 4 24C4 35 13 44 24 44Z" stroke="#d0d5dd" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <p style={{ fontSize: 15, fontWeight: 500, margin: '0 0 4px' }}>Select an event to get started</p>
          <p style={{ fontSize: 13, margin: 0 }}>Use the dropdowns above to pick events to compare.</p>
        </div>
      ) : loading ? (
        <CompareEventsChart loading={true} data={null} />
      ) : !error && (
        <CompareEventsChart loading={false} data={data} />
      )}
    </ReportingPageLayout>
  );
}

export default ReportingCompareEventsPage;
